import React from 'react';
import PropTypes from 'prop-types';
import 'leaflet/dist/leaflet.css';
import {
  Marker,
  Popup,
} from 'react-leaflet';
import styled from 'styled-components';
import Map from '../Map';
import CardList from '../CardList';
import Card from '../Card';
import BannerImage from '../BannerImage';
import WeatherTeaser from '../WeatherTeaser';
import Attributes from '../Attributes';

// Style
// import './Location.css';

const StyledLocation = styled.div`
  display: grid;
  grid-gap: 1.5rem;
  grid-auto-flow: dense;
  grid-template-columns: 0 1fr 0;

  > * {
    grid-column: 2 / -2;
  }

  .Location--Name {
    grid-column: 1 / -1;
  }

  .leaflet-container {
    height: 600px;
    width: 100%;
    margin: 0;
  }

  .Location--Map {
    height: 600px;
    max-height: 80vh;
  }

  .Location--FishList {
    margin: 0;
  }


  @media (min-width: ${t => t.theme.desktopBreakpoint}) {
    grid-template-columns: 0 2fr 1fr 0;

    > * {
      grid-column: 2 / span 1;
    }

    .Location--Name {
      grid-column: 1 / -1;
    }
  }

  @media (min-width: 1800px) {
    grid-template-columns: 0 1000px 1fr 0;
  }

`;

const StyledLocationAttribues = styled.div`
  @media (min-width: ${t => t.theme.desktopBreakpoint}) {
    grid-column: 3 / -2;
  }
`;

function Location({
  name,
  description,
  imageBanner,
  position,
  parking,
  washrooms,
  wheelchairWashrooms,
  boatLaunch,
  boatRental,
  fishObservation,
  commonFish,
  possibleFish,
  seasonalFish,
  ttc,
  telephone,
  userFee,
  disabledAccess,
  iceFishing,
  weather,
}) {
  return (
    <StyledLocation>
      <BannerImage className="Location--Name" img={imageBanner} title={name} />

      <Map
        center={position}
        className="Location--Map"
      >
        <Marker position={position}>
          <Popup>
            <h3>
              {name}
            </h3>
            <a
              href={`https://maps.google.com/maps/@${position[0]},${position[1]},15z`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Get directions
            </a>
          </Popup>
        </Marker>
      </Map>

      <StyledLocationAttribues>
        <Attributes
          arr={[
            {
              name: 'Parking',
              value: parking,
            },
            {
              name: 'Washrooms',
              value: washrooms,
            },
            {
              name: 'Wheelchair accessible washrooms',
              value: wheelchairWashrooms,
            },
            {
              name: 'Boat launch',
              value: boatLaunch,
            },
            {
              name: 'Boat rentals',
              value: boatRental,
            },
            {
              name: 'Fish observation',
              value: fishObservation,
            },
            {
              name: 'TTC',
              value: ttc,
            },
            {
              name: 'Telephone',
              value: telephone,
            },
            {
              name: 'User fee',
              value: userFee,
            },
            {
              name: 'Disabled access',
              value: disabledAccess,
            },
            {
              name: 'Ice fishing',
              value: iceFishing,
            },
          ]}
        />
      </StyledLocationAttribues>

      {commonFish && commonFish.length > 0 && (
        <React.Fragment>
          <h2>
            Common fish
          </h2>
          <CardList cards={commonFish} />
        </React.Fragment>
      )}

      {possibleFish && possibleFish.length > 0 && (
        <React.Fragment>
          <h2>
            Common fish
          </h2>
          <CardList cards={possibleFish} />
        </React.Fragment>
      )}

      {seasonalFish && seasonalFish.length > 0 && (
        <React.Fragment>
          <h2>
            Common fish
          </h2>
          <CardList cards={seasonalFish} />
        </React.Fragment>
      )}

      {description && description.length > 0 && (
        <React.Fragment>
          { /* eslint-disable-next-line react/no-danger */ }
          <div className="Location--Description" dangerouslySetInnerHTML={{ __html: description }} />
        </React.Fragment>
      )}

      {weather && (
        <div className="Location--Weather">
          <WeatherTeaser weather={weather} />
        </div>
      )}
    </StyledLocation>
  );
}

Location.propTypes = {
  name: PropTypes.string,
  description: PropTypes.string,
  imageBanner: PropTypes.string,
  position: PropTypes.arrayOf(PropTypes.number),
  parking: PropTypes.bool,
  washrooms: PropTypes.bool,
  wheelchairWashrooms: PropTypes.bool,
  boatLaunch: PropTypes.bool,
  boatRental: PropTypes.bool,
  fishObservation: PropTypes.bool,
  commonFish: PropTypes.arrayOf(PropTypes.shape(Card.propTypes)),
  possibleFish: PropTypes.arrayOf(PropTypes.shape(Card.propTypes)),
  seasonalFish: PropTypes.arrayOf(PropTypes.shape(Card.propTypes)),
  ttc: PropTypes.bool,
  telephone: PropTypes.bool,
  userFee: PropTypes.bool,
  disabledAccess: PropTypes.bool,
  iceFishing: PropTypes.bool,
  weather: PropTypes.shape(WeatherTeaser.propTypes),
};
Location.defaultProps = {
  name: '',
  description: '',
  imageBanner: '',
  position: [0, 0],
  parking: false,
  washrooms: false,
  wheelchairWashrooms: false,
  boatLaunch: false,
  boatRental: false,
  fishObservation: false,
  commonFish: [],
  possibleFish: [],
  seasonalFish: [],
  ttc: false,
  telephone: false,
  userFee: false,
  disabledAccess: false,
  iceFishing: false,
  weather: {},
};

export default Location;



// WEBPACK FOOTER //
// ./src/Components/Location/index.jsx